import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  salesMessage: string | undefined;
  traderMessage: string | undefined;
}>;

export type MessagesProps = OwnProps & StateProps;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (state, { tabId }) => {
  return {
    salesMessage: liveReferentialSelectors.getSalesMessage(state, tabId),
    traderMessage: liveReferentialSelectors.getTraderMessage(state, tabId),
  };
};

export const connectLiveMessages = connect(mapStateToProps);
